<template>
  <div>
    <header-component />
    <div class="main_banner">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="6" md="6" sm="12">
            <div class="left_section">
              <p>Instant Online Loan</p>
              <h1>
                Free loan
                <br />up to PHP 10 000,
                <br />for each new
                <br />client!
              </h1>
              <h4>Up to PHP 25 000 for up to 180 days for repeat</h4>
            </div>
          </b-col>
          <b-col cols="12" lg="6" md="6" sm="12">
            <div class="right_section">
              <estimator />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="content_candidate">
      <b-container fluid>
        <div class="box_features">
          <b-row>
            <b-col cols="12" lg="3" md="6" sm="12">
              <div class="box_f">
                <img src="@/assets/images/icons/time.png" alt />
                <h4>Quick and Easy</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur
                  adipiscing elit, sed do eiusmod tempo.
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="3" md="6" sm="12">
              <div class="box_f">
                <img src="@/assets/images/icons/tik.png" alt />
                <h4>No Penalties</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur
                  adipiscing elit, sed do eiusmod tempo.
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="3" md="6" sm="12">
              <div class="box_f">
                <img src="@/assets/images/icons/payment.png" alt />
                <h4>Low Rates</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur
                  adipiscing elit, sed do eiusmod tempo.
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="3" md="6" sm="12">
              <div class="box_f">
                <img src="@/assets/images/icons/credit.png" alt />
                <h4>Secure Process</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur
                  adipiscing elit, sed do eiusmod tempo.
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="eligible_cont mt-4">
          <h3>Who is eligible to apply?</h3>
          <div class="elig_item">
            <img src="@/assets/images/icons/21.png" alt />
            <p>21-70 years old</p>
          </div>
          <div class="elig_item">
            <img src="@/assets/images/icons/buss.png" alt />
            <p>
              Employed individuals
              <br />and selected professionals
            </p>
          </div>
          <div class="elig_item">
            <img src="@/assets/images/icons/loc.png" alt />
            <p>Filipino Residents</p>
          </div>
        </div>
      </b-container>
    </div>
    <div class="service_features">
      <b-container fluid>
        <div class="features">
          <h3>Service Features</h3>
          <b-row>
            <b-col cols="12" lg="6" md="6" sm="12">
              <div class="feature_items">
                <img src="@/assets/images/icons/internet.png" alt />
                <p>
                  All operations are performed online - you don't have to
                  leave your house
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="12">
              <div class="feature_items">
                <img src="@/assets/images/icons/docs.png" alt />
                <p>
                  We don't require guarantors representation,
                  documentation, or guarantee deposits.
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="12">
              <div class="feature_items">
                <img src="@/assets/images/icons/money.png" alt />
                <p>
                  In only 4 minutes you can receive up to 5000 pesos in
                  your bank account
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" sm="12">
              <div class="feature_items">
                <img src="@/assets/images/icons/docs.png" alt />
                <p>The service is fully automated</p>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="steps">
          <h3>Apply Now</h3>
          <b-row>
            <b-col cols="12" lg="3" md="3" sm="6">
              <div class="step_item">
                <img src="@/assets/images/icons/user.png" alt />
                <p>
                  Step 1
                  <br />Account information
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="3" md="3" sm="6">
              <div class="step_item">
                <img src="@/assets/images/icons/essay.png" alt />
                <p>
                  Step 2
                  <br />Personal data
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="3" md="3" sm="6">
              <div class="step_item">
                <img src="@/assets/images/icons/essay.png" alt />
                <p>
                  Step 3
                  <br />Employment details
                </p>
              </div>
            </b-col>
            <b-col cols="12" lg="3" md="3" sm="6">
              <div class="step_item">
                <img src="@/assets/images/icons/money.png" alt />
                <p>
                  Step 4
                  <br />Getting money
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-button class="service_apply">Apply Now</b-button>
      </b-container>
    </div>
    <div class="loan_terms">
      <b-container fluid>
        <h3>
          An Instant Online Loan is an online installment form of credit
          <br />with comfortable repayment terms
        </h3>
        <b-row>
          <b-col cols="12" lg="4" md="4" sm="12">
            <div class="terms_item">
              <p class="title">Terms</p>
              <p class="content wide">3 4 5 6</p>
              <p class="art">months</p>
            </div>
          </b-col>
          <b-col cols="12" lg="4" md="4" sm="12">
            <div class="terms_item">
              <p class="title">Amounts</p>
              <p class="content">10 500 to 25 000</p>
              <p class="art">PHP</p>
            </div>
          </b-col>
          <b-col cols="12" lg="4" md="4" sm="12">
            <div class="terms_item">
              <p class="title">INTEREST RATES</p>
              <p class="content">11.9% per month</p>
              <p class="art">maximum APR = 143%</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";
import estimator from "@/components/estimator.vue";

export default {
  components: {
    headerComponent,
    estimator,
    footerComponent
  },
  beforeMount() {
    window.scrollTo(0, 0);
  }  
};
</script>

<style lang="scss" scoped>
.main_banner {
  height: 720px;
  width: 100%;
  background: url("../../assets/images/banner-blue.jpg");
  background-position: center;
  background-size: cover;
  position: relative;
  padding: 60px 0;
  .left_section * {
    color: #fff;
    font-weight: 600;
    letter-spacing: 5px;
  }
  p {
    font-size: 1.684vw;
  }
  h1 {
    font-size: 3.734vw;
    margin-top: 40px;
  }
  h4 {
    font-size: 2.35vw;
    margin-top: 60px;
  }
  .right_section {
    display: flex;
    justify-content: flex-end;
  }
}
.content_candidate {
  padding: 0 0 100px;
  background-color: $bg-lightgray;
  .box_features {
    position: relative;
    top: -75px;
    .box_f {
      background-color: rgb(255, 255, 255);
      box-shadow: 2.5px 4.33px 8px 0px rgba(0, 0, 0, 0.15);
      width: 100%;
      height: 329px;
      border-bottom: 4px solid $base-color-lightblue;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex-direction: column;
      text-align: center;
      padding: 20px;
      h4 {
        font-weight: 700;
      }
    }
  }
  .eligible_cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    h3 {
      font-size: 24px;
      font-weight: 600;
    }
    .elig_item {
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        margin-bottom: 0;
        font-weight: 600;
        margin-left: 20px;
      }
    }
  }
}
.service_features {
  padding: 60px 0;
  background: url("../../assets/images/bg2.jpg") no-repeat;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  h3 {
    color: white;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .feature_items {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 60px;
    img {
      margin-right: 50px;
    }
    p {
      color: #fff;
      margin-bottom: 0;
      padding-right: 50px;
    }
  }
  .steps {
    margin-top: 40px;
    .step_item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      img {
        margin-right: 40px;
      }
      p {
        color: #fff;
        margin-bottom: 0;
      }
    }
  }
  .service_apply {
    height: 60px;
    color: #fff;
    text-align: center;
    background-color: $base-color-red;
    width: 342px;
    margin: 0 auto;
    border: 0;
    margin-top: 40px;
    text-transform: uppercase;
    display: block;
  }
  @media (max-width: 600px) {
    .service_apply {
      width: 100%;
    }
  }
}
.loan_terms {
  padding: 60px 0 120px;
  background-color: $bg-lightgray;
  h3 {
    font-size: 24px;
    margin-bottom: 60px;
  }
  .terms_item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url("../../assets/images/icons/bg_item.png") no-repeat;
    background-size: cover;
    background-position: center;
    height: 240px;
    width: 100%;
    border-radius: 8px;
    text-align: center;
    color: #fff;
    margin-bottom: 20px;
    .title {
      font-size: 24px;
      font-weight: 400;
      text-transform: uppercase;
      margin-bottom: 5px;
    }
    .content {
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 5px;
    }
    .content.wide {
      letter-spacing: 15px;
    }
    .art {
      font-size: 20px;
      font-weight: 400;
      margin-bottom: 5px;
    }
  }
}
@media (max-width: 992px) {
  .main_banner {
    height: auto;
    h1 {
       font-size: 36px;
    }
    p, h4 {
      font-size: 20px;
    }
  }

  .elig_item {
    margin-bottom: 20px;
  }

  .content_candidate {
    padding: 60px 0;
    .box_features {
      top: 0;
      .box_f {
        margin-bottom: 20px;
      }
    }
  }
}
</style>